import React from "react";
import { Users, ShoppingBag, MessageSquare, Settings } from 'lucide-react';
import { Link } from "react-router-dom";

const AdminDashboard = ({ totalOrders, totalUsers }) => {
  const adminCards = [
    {
      title: "Total Orders",
      link: "/admin/orders",
      linkText: "Manage all your orders",
      icon: <ShoppingBag size={32} />,
      value: totalOrders.toLocaleString(), // Use dynamic data here
      growth: "",
      bgColor: "bg-blue-100",
      iconColor: "text-blue-500",
      borderColor: "border-blue-200"
    },
    {
      title: "Total Users",
      link: "/admin/users",
      linkText: "View and manage users",
      icon: <Users size={32} />,
      value: totalUsers.toLocaleString(), // Use dynamic data here
      growth: "",
      bgColor: "bg-green-100",
      iconColor: "text-green-500",
      borderColor: "border-green-200"
    },
    {
      title: "Support Messages",
      link: "/admin/support-messages",
      linkText: "Customer support tickets",
      icon: <MessageSquare size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-purple-100",
      iconColor: "text-purple-500",
      borderColor: "border-purple-200"
    },
    {
      title: "Settings",
      link: "/admin/settings",
      linkText: "Configure system settings",
      icon: <Settings size={32} />,
      value: "",
      growth: "",
      bgColor: "bg-gray-100",
      iconColor: "text-gray-500",
      borderColor: "border-gray-200"
    }
  ];

  return (
    <div className="container py-6">
      <div className="row mb-4">
        <div className="col-12">
          <p className="text-gray-500">Welcome back! Here's your dashboard overview</p>
        </div>
      </div>

      <div className="row g-4">
        {adminCards.map((card, index) => (
          <div key={index} className="col-xl-3 col-lg-6 col-md-6">
            <Link 
              to={card.link} 
              className="text-decoration-none"
              style={{ display: 'block' }}
            >
              <div className={`card shadow-sm h-100 border ${card.borderColor} hover:shadow-lg transition-all duration-200`}>
                <div className={`card-body p-4 ${card.bgColor}`}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className={`p-2 rounded-circle ${card.bgColor} ${card.iconColor}`}>
                      {card.icon}
                    </div>
                    {card.growth && (
                      <span className="badge bg-success text-white p-2">
                        {card.growth}
                      </span>
                    )}
                  </div>

                  <h5 className="card-title mb-1 text-lg font-semibold">{card.title}</h5>

                  {card.value && (
                    <h3 className="display-6 fw-bold mb-0">{card.value}</h3>
                  )}

                  <span className="btn card-text mt-2 mb-0 text-gray-600 text-sm">
                    {card.linkText}
                  </span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboard;
